module.exports = __webpack_public_path__ + "static/media/bigLogo.f086adfc.svg";